import { useState } from "react";

const additionalServices = [
  {
    id: "fascia-soffit",
    title: "Fascia & Soffit Cleaning",
    tagline: "Restore your roofline to like-new condition",
    icon: "ri-home-smile-fill",
    color: "#0E7490",
    bgLight: "#ECFEFF",
    image: "https://public.readdy.ai/ai/img_res/91c04713c2a77c2358c7dca9a94fcc15.jpg",
    desc: "Over time, your fascia and soffit boards accumulate algae, black mould, moss, and stubborn grime — leaving your roofline looking neglected and potentially causing long-term damage. Our professional fascia and soffit cleaning service in Northfleet, Gravesend and Kent uses a specialist soft-wash process that safely and thoroughly removes biological growth and staining from all uPVC, timber, and composite roofline materials — restoring them to a bright, clean finish without causing any damage.",
    benefits: [
      "Safe soft-wash cleaning process",
      "Removes algae, mould & black staining",
      "All uPVC, timber & composite materials",
      "Protects against premature deterioration",
      "Improves kerb appeal instantly",
      "Covers Northfleet, Gravesend & Kent",
    ],
  },
  {
    id: "cladding",
    title: "Cladding Cleaning",
    tagline: "Keep your exterior looking sharp and well-maintained",
    icon: "ri-building-fill",
    color: "#374151",
    bgLight: "#F3F4F6",
    image: "https://readdy.ai/api/search-image?query=modern%20UK%20building%20exterior%20with%20immaculate%20clean%20grey%20composite%20cladding%20panels%2C%20perfectly%20restored%20original%20colour%20with%20no%20algae%20or%20staining%20visible%2C%20wide%20angle%20architectural%20exterior%20photography%2C%20bright%20overcast%20daylight%2C%20ultra%20sharp%20photorealistic%20high%20definition%2C%20no%20people%2C%20professional%20commercial%20photography%2C%20clean%20crisp%20lines%2C%20award%20winning%20architectural%20photography&width=800&height=500&seq=svc-cladding-v3&orientation=landscape",
    desc: "Dirty, stained cladding can make even a well-maintained property look run-down. Whether your building features render, composite panels, timber boards, or UPVC cladding, Mighty Cleaning Services Ltd provides expert exterior cladding cleaning across Northfleet, Gravesend and Kent. Our low-pressure soft-wash technique penetrates deep into surface pores to lift and remove algae, lichen, dirt, and pollution staining — delivering a thorough, long-lasting clean that revives the full appearance of your property's exterior.",
    benefits: [
      "All cladding types: render, composite, uPVC, timber",
      "Low-pressure soft-wash technique",
      "Removes algae, lichen & pollution staining",
      "Residential and commercial properties",
      "Restores original colour and appearance",
      "Long-lasting results with biocide treatment",
    ],
  },
  {
    id: "pressure-washing",
    title: "Pressure Washing",
    tagline: "Blast away grime from every hard surface",
    icon: "ri-drop-fill",
    color: "#1D4ED8",
    bgLight: "#EFF6FF",
    image: "https://readdy.ai/api/search-image?query=immaculate%20freshly%20pressure%20washed%20block%20paving%20driveway%20outside%20a%20neat%20UK%20suburban%20home%2C%20half%20clean%20half%20dirty%20dramatic%20before%20and%20after%20contrast%20visible%2C%20gleaming%20wet%20paving%20stones%20reflecting%20sky%20after%20cleaning%2C%20bright%20sunlight%2C%20wide%20angle%20overhead%20or%20low%20angle%20shot%2C%20ultra%20sharp%20photorealistic%20crystal%20clear%2C%20no%20people%2C%20professional%20photography%2C%20high%20definition%20striking%20result&width=800&height=500&seq=svc-pressure-v3&orientation=landscape",
    desc: "From driveways and patios to commercial car parks and forecourts, our professional pressure washing service in Northfleet, Gravesend and across Kent transforms tired, grimy surfaces back to their best. Using commercial-grade hot and cold pressure washing equipment, our trained team removes ingrained moss, algae, oil stains, chewing gum, and years of built-up dirt from block paving, concrete, tarmac, natural stone, brick, and decking — making your outdoor spaces safe, clean, and visually impressive.",
    benefits: [
      "Driveways, patios & pathways",
      "Commercial forecourts & car parks",
      "Hot & cold water systems available",
      "Removes oil, algae & moss safely",
      "All surface types treated",
      "Re-sanding and sealing also available",
    ],
  },
  {
    id: "solar-panel",
    title: "Solar Panel Cleaning",
    tagline: "Maximise energy output with professionally cleaned panels",
    icon: "ri-sun-fill",
    color: "#D97706",
    bgLight: "#FFFBEB",
    image: "https://readdy.ai/api/search-image?query=perfectly%20clean%20gleaming%20photovoltaic%20solar%20panels%20on%20a%20residential%20UK%20rooftop%20sparkling%20in%20bright%20sunshine%2C%20crystal%20clear%20glass%20surfaces%20reflecting%20blue%20sky%2C%20wide%20angle%20aerial%20style%20rooftop%20photography%2C%20immaculate%20result%20with%20no%20dust%20or%20bird%20droppings%2C%20ultra%20sharp%20photorealistic%20high%20definition%2C%20no%20people%20visible%2C%20professional%20architectural%20photography&width=800&height=500&seq=svc-solar-v3&orientation=landscape",
    desc: "Dirty solar panels can lose up to 25% of their energy output due to the build-up of dust, bird droppings, algae, and pollution. Regular professional solar panel cleaning in Northfleet, Gravesend and across Kent ensures your solar investment continues to perform at its maximum efficiency. Our specialists use a purified water-fed pole system — the same streak-free technology we use for window cleaning — which is completely safe for all solar panel types and leaves no residue, detergent, or scratching on the delicate surface.",
    benefits: [
      "Restores up to 25% lost energy output",
      "Purified water-fed pole system",
      "Safe for all solar panel types",
      "No detergents — streak and residue free",
      "Bird dropping & algae removal",
      "Regular maintenance plans available",
    ],
  },
  {
    id: "conservatory-roof",
    title: "Conservatory Roof Cleaning",
    tagline: "Let the light back in with a spotless conservatory roof",
    icon: "ri-sun-cloudy-line",
    color: "#059669",
    bgLight: "#ECFDF5",
    image: "https://readdy.ai/api/search-image?query=stunning%20crystal%20clear%20clean%20polycarbonate%20conservatory%20roof%20panels%20sparkling%20in%20bright%20afternoon%20sunlight%2C%20absolutely%20spotless%20with%20no%20algae%20green%20staining%20or%20mould%2C%20bright%20interior%20light%20flooding%20through%20gleaming%20roof%2C%20wide%20angle%20exterior%20shot%20of%20pristine%20white%20uPVC%20conservatory%2C%20UK%20suburban%20garden%2C%20ultra%20sharp%20photorealistic%2C%20no%20people%2C%20professional%20architectural%20photography%2C%20award%20winning%20composition&width=800&height=500&seq=svc-conroof-v3&orientation=landscape",
    desc: "Green algae, black mould, and lichen growth on your conservatory roof isn't just unsightly — it blocks natural light, causes discolouration, and can lead to irreversible surface damage if left untreated. Our specialist conservatory roof cleaning service across Northfleet, Gravesend and Kent uses a specially formulated soft-wash system to safely deep-clean polycarbonate panels, glass roofs, and all ridge, hip and valley details — without the risk of high-pressure damage. We remove all biological growth and staining at a root level, leaving your conservatory roof crystal clear and treated to slow future regrowth.",
    benefits: [
      "Polycarbonate & glass roof panels",
      "Removes algae, mould & lichen at root",
      "Safe soft-wash — no high-pressure damage",
      "Ridge, hip & valley detail cleaning",
      "Biocide treatment to slow regrowth",
      "Dramatically improves natural light",
    ],
  },
];

export default function AdditionalServices() {
  const [hovered, setHovered] = useState<string | null>(null);

  return (
    <section className="py-24" style={{ background: "#F8FAFC" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block font-heading font-semibold text-sm uppercase tracking-widest text-[#1E88E5] mb-3">
            More Services
          </span>
          <h2
            className="font-heading text-[#0F2040] leading-tight mb-5"
            style={{ fontSize: "clamp(1.75rem, 3vw, 2.5rem)", fontWeight: 800 }}
          >
            Specialist Exterior Cleaning Services
          </h2>
          <p className="font-body text-gray-600 text-lg leading-relaxed max-w-2xl mx-auto">
            Beyond windows and gutters, we offer a full range of specialist exterior cleaning services for homes and businesses across Gravesend, Northfleet and Kent.
          </p>
        </div>

        {/* Services Grid */}
        <div className="space-y-20">
          {additionalServices.map((service, index) => (
            <article
              key={service.id}
              id={service.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-start ${
                index % 2 === 1 ? "lg:[direction:rtl]" : ""
              }`}
            >
              {/* Image */}
              <div
                className="w-full h-80 rounded-2xl overflow-hidden lg:[direction:ltr] cursor-pointer"
                onMouseEnter={() => setHovered(service.id)}
                onMouseLeave={() => setHovered(null)}
              >
                <img
                  src={service.image}
                  alt={`${service.title} in Northfleet, Gravesend and Kent`}
                  className={`w-full h-full object-cover object-top transition-transform duration-500 ${
                    hovered === service.id ? "scale-105" : "scale-100"
                  }`}
                />
              </div>

              {/* Content */}
              <div className="lg:[direction:ltr]">
                <div className="flex items-center gap-3 mb-4">
                  <div
                    className="w-12 h-12 flex items-center justify-center rounded-xl"
                    style={{ backgroundColor: service.bgLight }}
                  >
                    <i className={`${service.icon} text-xl`} style={{ color: service.color }}></i>
                  </div>
                  <span
                    className="font-heading font-semibold text-sm uppercase tracking-widest"
                    style={{ color: service.color }}
                  >
                    {service.tagline}
                  </span>
                </div>
                <h2
                  className="font-heading text-[#0F2040] leading-tight mb-4"
                  style={{ fontSize: "clamp(1.5rem, 2.5vw, 2rem)", fontWeight: 800 }}
                >
                  {service.title}
                </h2>
                <p className="text-gray-600 font-body text-base leading-relaxed mb-7">
                  {service.desc}
                </p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-7">
                  {service.benefits.map((benefit) => (
                    <li key={benefit} className="flex items-start gap-2.5">
                      <i
                        className="ri-check-line text-sm mt-0.5 flex-shrink-0"
                        style={{ color: service.color }}
                      ></i>
                      <span className="font-body text-sm text-gray-600">{benefit}</span>
                    </li>
                  ))}
                </ul>
                <div className="flex flex-wrap gap-4">
                  <a
                    href="#quote-form"
                    className="flex items-center gap-2 text-white font-heading font-semibold text-sm px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                    style={{ backgroundColor: service.color }}
                  >
                    <i className="ri-file-list-3-line"></i>
                    Get a Free Quote
                  </a>
                  <a
                    href="tel:02084322244"
                    className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-[#1A3A6B] font-heading font-semibold text-sm px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-phone-fill"></i>
                    Call Now
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
